import { handleErrors } from './ErrorActions';
import smartSolveApi from '../api/instances/smartsolve';

export const FETCH_CREATE_PAT = 'FETCH_CREATE_PAT';
export const FETCH_CREATE_PAT_FAILURE = 'FETCH_CREATE_PAT_FAILURE';
export const FETCH_CREATE_PAT_SUCCESS = 'FETCH_CREATE_PAT_SUCCESS';
export const FETCH_REVOKE_PAT = 'FETCH_REVOKE_PAT';
export const FETCH_REVOKE_PAT_FAILURE = 'FETCH_REVOKE_PAT_FAILURE';
export const FETCH_REVOKE_PAT_SUCCESS = 'FETCH_REVOKE_PAT_SUCCESS';

export const fetchCreatePat = () => ({
  type: FETCH_CREATE_PAT,
});

export const fetchCreatePatSuccess = ({ message, pat }) => ({
  type: FETCH_CREATE_PAT_SUCCESS,
  message,
  pat,
});

export const fetchCreatePatFailure = () => ({
  type: FETCH_CREATE_PAT_FAILURE,
});

export const fetchCreatePatFromServer = () => (dispatch) => {
  dispatch(fetchCreatePat());

  return smartSolveApi
    .post('/createpat', {})
    .then((response) => {
      const { data } = response;
      if (data.hasError) {
        dispatch(fetchCreatePatFailure());
        dispatch(handleErrors(data.errors, { isTopBanner: true }));
      } else {
        dispatch(fetchCreatePatSuccess(data));
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(`Fetching Create PAT failed: ${JSON.stringify(error)}`);
      dispatch(fetchCreatePatFailure(error));
      dispatch(handleErrors(error, { isTopBanner: true }));
    });
};

export const fetchRevokePat = () => ({
  type: FETCH_REVOKE_PAT,
});

export const fetchRevokePatSuccess = ({ message }) => ({
  type: FETCH_REVOKE_PAT_SUCCESS,
  message,
});

export const fetchRevokePatFailure = ({ message }) => ({
  type: FETCH_REVOKE_PAT_FAILURE,
  message,
});

export const fetchRevokePatFromServer = () => (dispatch) => {
  dispatch(fetchRevokePat());

  return smartSolveApi
    .post('/revokepat', {})
    .then((response) => {
      const { data } = response;
      if (data.hasError) {
        dispatch(fetchCreatePatFailure());
        dispatch(handleErrors(data.errors, { isTopBanner: true }));
      } else {
        dispatch(fetchRevokePatSuccess(data));
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(`Fetching Revoke PAT failed: ${JSON.stringify(error)}`);
      dispatch(fetchRevokePatFailure(error));
      dispatch(handleErrors(error, { isTopBanner: true }));
    });
};
